import BikeInfo from "../../BikeInfo/BikeInfo";
import { Cards } from "../../Cards/Cards";
import Hero from "../../Hero/Hero";
import { Footer} from "../../Footer/Footer"
import Intro from "../../Intro/Intro"
import { NewIntro } from "../../NewIntro/NewIntro";

import "./LandingPage.css"
import ServiceCards from "../../ServiceCards/ServiceCards";

const LandingPage = () => {
  return ( 



    <div className="Landing">
      <main className="LandingPage">
        <Hero/>
        <NewIntro/>
        <BikeInfo/>
        <ServiceCards/>



        <h5>My minimum callout charge is £35 (this includes labour up to the value of £35).</h5>
        <div className="LandingPage__card-container">
          
        <Cards  number={38} title={"Individual Jobs"} showprice={true} plusmore={""} Links={"/StandardService"} />

        <Cards  number={11} title={"Standard Service"} showprice={false} plusmore={""} Links={"/StandardService"}/>

        <Cards  number={20} title={"Advanced Service"} showprice={false} plusmore={""} Links={"/AdvancedService"}/>

        <Cards  number={20} title={"Full Service"} showprice={false} plusmore={"+ Plus more +"} Links={"FullService"}/>
        </div>

        <Footer/> 

      </main>
    </div>

   );
}
 
export default LandingPage;